/*
 * Copyright (c) Vencode. All rights reserved.
 */

Office.onReady(() => {});
